// projects/humanresources-personnel/src/assets/i18n/*/hr-per-object-detail.json
export class HrPerObjectDetailKey {
    private static readonly keyPrefix = 'hrPerObjectDetail';
    public static title = `${HrPerObjectDetailKey.keyPrefix}.title`;
    public static objectId = `${HrPerObjectDetailKey.keyPrefix}.objectId`;
    public static hrmPerDetailUuid = `${HrPerObjectDetailKey.keyPrefix}.hrmPerDetailUuid`;
    public static timeConstraint = `${HrPerObjectDetailKey.keyPrefix}.timeConstraint`;
}
